import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LoaderCustomFixed from "../ConfirmationModal/LoaderCustomFixed";

const PermitTypeDisplayForAdmin = ({ id }) => {
    const [fullPath, setFullPath] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const findItemAndParents = (items, id, parents = []) => {
        for (const item of items) {
            if (item.id === id) {
                return { path: [...parents, { title: item.title }], icon: '' };
            } else if (item.childrenPermitTypes && item.childrenPermitTypes.length) {
                const result = findItemAndParents(item.childrenPermitTypes, id, [...parents, { title: item.title }]);
                if (result.path) {
                    return {
                        path: result.path,
                        icon: ''
                    };
                }
            }
        }
        return { path: null, icon: '' };
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`);
                const { data } = response.data;
                const result = findItemAndParents(data, id);
                if (result.path) {
                    setFullPath(result.path.map(item => item.title).join(' / '));
                }
            } catch (error) {
            } finally {
                setIsLoading(false);
            }
        };

        void fetchData();
    }, [id]);



    return (
        <div>
            {isLoading ? (
                <div><LoaderCustomFixed/></div>
            ) : (
                <h1 className="permittype-title" title={fullPath}>{fullPath}</h1>
            )}

        </div>
    );
};

export default PermitTypeDisplayForAdmin;
